/**
 * Первый явный цвет текста из HTML контента новости (foreColor / style / font color).
 * Нужен, когда в БД нет поля contentColor, а цвет задан только в разметке редактора.
 */
export function extractFirstCssTextColorFromHtml(html) {
  if (!html || typeof html !== 'string') return '';
  const slice = html.slice(0, 20000);
  const fontM = slice.match(/<font\b[^>]*\bcolor\s*=\s*["']?([^"'>\s]+)/i);
  if (fontM && fontM[1]) {
    const t = fontM[1].trim();
    if (t && !/^(inherit|initial)$/i.test(t)) return t;
  }
  const re = /(?:^|[\s;{"'])color\s*:\s*([^;)"'<\r\n]+)/gi;
  let m;
  while ((m = re.exec(slice)) !== null) {
    let cand = m[1].trim().replace(/^["']+|["']+$/g, '').trim();
    if (!cand || /^(inherit|initial|unset|transparent|currentcolor)$/i.test(cand)) continue;
    return cand;
  }
  return '';
}
